import type { IconData } from '@stacksjs/iconify-core'

export const shoppingSecurity: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M1 0h14v8.518a6 6 0 0 1-3.023 5.21L8 16l-3.977-2.272A6 6 0 0 1 1 8.517z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shoppingSecurity
